import { t } from 'i18next';
import { RouteObject } from 'react-router-dom';
import { SetupClassesAndDivisions } from './ClassesAndDivisions/SetupClassesAndDivisions';
import { SetupDivisions } from './Divisions/SetupDivisions';
import { GradeGroups } from './GradeGroups/GradeGroups';
import { SetupPersons } from './Persons/SetupPersons';
import { SetupRoomsAndBuildings } from './RoomsAndBuildings/SetupRoomsAndBuildings';
import { SetupSchoolYears } from './SchoolYears/SetupSchoolYears';
import { SettingsPage } from './SettingsPage';
import { SettingsSetupSubjectsAndSubjectContainer } from './SubjectsAndSubjectContainer/SettingsSetupSubjectsAndSubjectContainer';
import { UsersPage } from './Users/UsersPage';

export const settingsRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      index: true,
      element: <SettingsPage />,
    },
    {
      path: t('routes.subjects.slug'),
      element: <SettingsSetupSubjectsAndSubjectContainer />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.subjects.slug')}`,
          title: t('routes.subjects.title'),
        }),
      },
    },
    {
      path: t('routes.teacher.slug'),
      element: <SetupPersons />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.teacher.slug')}`,
          title: t('routes.teacher.title'),
        }),
      },
    },
    {
      path: t('routes.classes.slug'),
      element: <SetupClassesAndDivisions />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.classes.slug')}`,
          title: t('routes.classes.title'),
        }),
      },
    },
    {
      path: t('routes.rooms.slug'),
      element: <SetupRoomsAndBuildings />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.rooms.slug')}`,
          title: t('routes.rooms.title'),
        }),
      },
    },
    {
      path: t('routes.schoolyear.slug'),
      element: <SetupSchoolYears />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.schoolyear.slug')}`,
          title: t('routes.schoolyear.title'),
        }),
      },
    },
    {
      path: t('routes.divisions.slug'),
      element: <SetupDivisions />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.divisions.slug')}`,
          title: t('routes.divisions.title'),
        }),
      },
    },
    {
      path: t('routes.gradeGroups.slug'),
      element: <GradeGroups />,
      handle: {
        crumb: () => ({
          slug: t('routes.gradeGroups.slug'),
          title: t('routes.gradeGroups.title'),
        }),
      },
    },
    {
      path: t('routes.users.slug'),
      element: <UsersPage />,
      handle: {
        crumb: () => ({
          slug: t('routes.users.slug'),
          title: t('routes.users.title'),
        }),
      },
    },
  ];
};
